<template>
  <div class="main-container">
    <div class="content-card p-3">
      <div v-if="!done">
        <div class="mb-2">
          <span class="content-card--title">
            {{ $t("pages.login.resetPasswordTitle") }}
          </span>
        </div>
        <div class="mb-5">
          <span>
            {{ $t("pages.login.resetPasswordDescription") }}
          </span>
        </div>
        <form @keyup.enter="signIn()" class="mb-5">
          <div class="content-card--input mb-3">
            <el-input
              type="password"
              class="input-inner"
              prefix-icon="el-icon-lock"
              :placeholder="$t('pages.login.newPassword')"
              v-model="password"
            />
          </div>
          <div>
            <div
              class="content-card--input mb-3"
              :class="!validPassword && 'invalid'"
            >
              <el-input
                type="password"
                class="input-inner"
                prefix-icon="el-icon-lock"
                :placeholder="$t('pages.login.repeatNewPassword')"
                v-model="confirmPassword"
              />
            </div>
            <span class="error-label mt-1 ml-3">
              {{ $t("components.horizontalInput.invalidEmail") }}
            </span>
          </div>
        </form>
        <el-button type="primary" @click="submitPassword">
          {{ $t("pages.login.confirmButton") }}
        </el-button>
      </div>
      <div v-else>
        <div class="mb-2">
          <span class="content-card--title">
            {{ $t("pages.login.passwordChangedTitle") }}
          </span>
        </div>
        <div class="mb-5">
          <span>
            {{ $t("pages.login.passwordChangedDescription") }}
          </span>
        </div>
        <el-button type="primary" @click="$router.push({ name: 'Login' })">
          {{ $t("pages.login.returnButton") }}
        </el-button>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  data() {
    return {
      password: '',
      confirmPassword: '',
      done: false,
    };
  },
  computed: {
    validPassword() {
      return (
        !this.confirmPassword.length || this.confirmPassword === this.password
      );
    },
  },
  methods: {
    async submitPassword() {
      // TODO
      try {
        // this.$route.params.token
        // await this.$store.dispatch('changePassword', { email: token.email });
        this.done = true;
      } catch (e) {
        this.$message.error(this.$t('pages.login.emailError'));
      }
    },
  },
};
</script>
<style lang="scss" scoped>
.main-container {
  min-height: 100vh;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  background-color: var(--primary);

  .content-card {
    width: 70%;
    max-width: 610px;
    text-align: center;
    background-color: var(--light-bg);
    border-radius: var(--border-radius);

    &--title {
      font-size: 36px;
      font-weight: 600;
      color: var(--primary);
    }

    &--input {
      display: flex;
      flex-direction: row;
      border-radius: 4px;
      border: 1px solid var(--input-border);

      &.invalid {
        border: 2px solid red;
        margin: -2px;

        & + .error-label {
          display: flex;
          color: red;
          font-size: 0.875rem;
        }
      }

      & + .error-label {
        display: none;
      }

      .input-inner {
        width: 100%;

        ::placeholder {
          /* Chrome, Firefox, Opera, Safari 10.1+ */
          color: var(--border-grey);
          opacity: 1; /* Firefox */
        }
        :-ms-input-placeholder {
          /* Internet Explorer 10-11 */
          color: var(--border-grey);
        }
        ::-ms-input-placeholder {
          /* Microsoft Edge */
          color: var(--border-grey);
        }

        ::v-deep .el-input__inner {
          border: none;
          border-top-left-radius: 0px;
          border-bottom-left-radius: 0px;
          height: 54px;
          padding: 0px 15px 0px 50px;
          background-color: var(--input-background);
        }

        ::v-deep .el-input__icon {
          width: 23px;
          font-size: 23px;
          margin-left: 10px;
          color: var(--primary);
          display: flex;
          align-items: center;
        }
      }
    }

    button {
      width: 100%;
      height: 54px;
      font-size: 18px;
    }
  }
}
</style>
